import bcrypt from "bcryptjs";
import CryptoJS from "crypto-js";

const { REACT_APP_SECRET_KEY } = process.env;

// export const encrypt = async (password) => {
//   const secretKey = REACT_APP_SECRET_KEY;

//   const salt = await bcrypt.genSalt(10);
//   return await bcrypt.hash(password + secretKey, salt);
// };

export const encrypt = (password) => {
  const secretKey = REACT_APP_SECRET_KEY;

  return CryptoJS.HmacSHA512(password, secretKey).toString();
};
